import { useState } from "react";

import Button from "@/components/Atoms/Button";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

import CallbackModal from "../CallbackModal";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./CallbackStrip.module.scss";
import { useAppSelector } from "@/hooks";

interface CallbackStripProps {
  variant?: string;
}

const CallbackStrip: React.FC<CallbackStripProps> = ({ variant = "" }) => {
  const cls = classNameGenerator(styles);

  const [showCallbackModal, setShowCallbackModal] = useState(false);

  const { data } = useAppSelector((state) => state.bootCamp);
  if(!data.showCallbackStrip)
    return <></>

  const title =
    "Want to know more before you book your spot? Speak to our team!";
  const ctaText = "Request a callback";
  const formTitle = "Speak to our team!";
  const formSubtitle = "You'll get a call back in 24 hours!";

  return (
    <section className={clsx(cls("callbackStrip"), cls(variant))}>
      <div className={cls("container")}>
        <div className={cls("leftSection")}>
          <SVGSprite icon="icon-bootcamp-phone" className={cls("icon")} />
          <Typography variant="heading3" className={cls("title")}>
            {title}
          </Typography>
        </div>
        <div className={cls("rightSection")}>
          <Button
            variant="primary"
            className={cls("actionButton")}
            onClick={() => setShowCallbackModal(true)}
          >
            {ctaText}
          </Button>
        </div>
      </div>
      <CallbackModal
        title={formTitle}
        subtitle={formSubtitle}
        showModal={showCallbackModal}
        setShowModal={setShowCallbackModal}
      />
    </section>
  );
};

export default CallbackStrip;
